// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris


type RuntimeEnvRecord = Record<string, string | boolean | undefined>;

export async function loadSiteConfig(configUrl = "/siteconfig.json"): Promise<void> {
  let siteConfig: Record<string, string>;
  try {
    const response = await fetch(configUrl);
    if (!response.ok) {
      return;
    }
    siteConfig = (await response.json()) as Record<string, string>;
  } catch {
    return;
  }

  const globalEnv = globalThis as { __RIDDLE_ENV__?: RuntimeEnvRecord };
  globalEnv.__RIDDLE_ENV__ = { ...(globalEnv.__RIDDLE_ENV__ ?? {}), ...siteConfig };
}
